import { gql, useMutation } from "@apollo/client";
import { ChannelType } from "../types/ChannelType";
import { CHANNEL_FIELDS } from "../types/ChannelType";

export interface ChannelInput {
    id?: string;
    channelName: string;
    companyName: string;
    companyAddress?: string;
    contactName?: string;
    contactPhone?: string;
    email?: string;
    taxRate?: string;
    taxId?: string;
    isAutoGenerate: boolean;
    isSetSettlementConfig: boolean;
    settlementCustomerType: number;
    settlementTrackingPoint: string | null;
    billingCycleConfiguration: number;
    weightCalculationMode: number;
    weightCalculationThresholdX?: number;
    settlementMode: number;
    billType?: number[];
    billUnitType: number;
    timeZoneIana?: string;
    schemeLimitNode?: string;
    status: number;
    remark?: string;
}

export const SAVE_CHANNEL = gql`
    mutation SaveChannel($input: ChannelTypeInput!) {
        saveChannel(input: $input) {
            ...ChannelFields
        }
    }
    ${CHANNEL_FIELDS}
`;

export interface SaveChannelResponse {
    saveChannel: ChannelType;
}

export interface SaveChannelVariables {
    input: ChannelInput;
}

export const useSaveChannel = () => {
    return useMutation<SaveChannelResponse, SaveChannelVariables>(SAVE_CHANNEL);
}; 